<template>
    <div class="item-columns">
        <div class="item col-8 m-0 p-0">
            {{ __('messages.colombians_vat_messages') }}
        </div>
        <div class="item-right">
                <currency-display :amount="breakdown.amount" :showCurrencyCode="true"
                :applyDecimals="true"></currency-display>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        showBox: false,
        breakdown: {}
    },
    data() {
        return {
            data: {}
        };
    },
    async mounted() {
    }
}
</script>
